
import styled from "styled-components";
import { } from "../../../constants";

export const NavTab = styled.div``;
